import { Component, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { first } from 'rxjs/operators';

import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@shared/models/modal.model';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { UserService } from '@shared/services/user.service';
import { User } from '@shared/models/user.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { Observable } from 'rxjs';
import { RecurringRankingComponent } from '@shared/components/recurring-ranking/recurring-ranking.component';
import { RecurringHallComponent } from '@shared/components/recurring-hall/recurring-hall.component';
import { SharedModule } from '@app/shared/shared.module';
import { ShopRecurringBagComponent } from '@app/shared/components/shop-recurring-bag/shop-recurring-bag.component';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-user-trophies-modal',
  templateUrl: './user-trophies-modal.component.html',
  styleUrls: ['./user-trophies-modal.component.scss'],
  standalone: true,
  imports: [RecurringRankingComponent, RecurringHallComponent, SharedModule, ShopRecurringBagComponent],
  encapsulation: ViewEncapsulation.None,
})
export class UserTrophiesModalComponent implements OnInit {
  private userService = inject(UserService);
  logger = inject(LoggerService);
  private eventManager = inject(EventManager);
  baseModalData = inject<ModalConfig>(MAT_DIALOG_DATA);

  baseModalConfiguration: ModalConfig;
  h_Disabled = false;
  r_Disabled = false;
  both_Disabled = false;
  user: User;

  componentDestroy: () => Observable<unknown>;

  constructor() {
    const baseModalData = this.baseModalData;

    this.baseModalConfiguration = baseModalData;
  }

  ngOnInit() {
    this.userService.currentUser$.pipe(first()).subscribe({
      next: (user: User) => {
        this.user = user;
      },
      error: (error) => this.logger.error(error),
    });
  }

  public closeModal() {
    this.eventManager.closeModal(
      new Modal(NonPersistedModalName.UserTrophiesModalComponent, ModalType.View, this.baseModalData)
    );
  }

  public openInfo() {
    this.eventManager.openModal(new Modal(NonPersistedModalName.InfoUserTrophiesModalComponent, ModalType.View));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public trophiesDisabled(event: any) {
    this.h_Disabled = event;
    this.bothDisabled();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public rankingDisabled(event: any) {
    this.r_Disabled = event;
    this.bothDisabled();
  }

  private bothDisabled() {
    if (this.h_Disabled && this.r_Disabled) {
      this.both_Disabled = true;
    }
  }
}
